module.exports = __webpack_public_path__ + "img/20190627161907651.a2e5bf19.png";